import palette from "./palette";
import shape from "./shape";
import shadows from "./shadows";
import typeset from "./typeset";
//import spacing from "./spacing";

const CMS2 = {
    palette: palette,
    shadows: shadows,
    shape: shape,
    //spacing:spacing,
    typography: typeset
}
export default CMS2